<template>
  <!-- Table -->
  <DataView ref="dataViewRef" v-bind="tableConfigRef" />

  <!-- Modal -->
  <DataSourcesDialogView ref="modalRef" @saved="updateTableList" />
</template>

<script setup>
import { ref } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import { DataView, useImmer } from "@sttedra_ui/framework";

import useTableConfig from "@/pages/_root/data-sources/data-sources-table.view-config.js";
import DataSourcesDialogView from "@/pages/_root/data-sources-dialog/DataSourcesDialogView.vue";
import { dataSourcesDelete } from "@/api/data-sources/data-sources.api.js";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const confirm = useConfirm();
const toast = useToast();
const modalRef = ref(null);
const dataViewRef = ref(null);
const tableConfig = new useTableConfig(buildModal, deleteRegister);
const { ref: tableConfigRef } = useImmer(tableConfig);
// #endregion

// #region Functions
function buildModal(event = null, action = null) {
  modalRef.value.showModal(event ? event.data : null, action);
}

function deleteRegister({ data }) {
  confirm.require({
    message: "¿Desea borrar el registro?",
    header: "Borrar",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      const response = await dataSourcesDelete(data.idFuente);

      if (response.data == true || response.data == "") {
        toast.add({
          severity: "success",
          summary: "Registro borrado",
          detail: `Se ha borrado el registro correctamente`,
          life: 3000,
        });

        updateTableList();
      } else {
        toast.add({
          severity: "error",
          summary: "Error",
          detail: "Ha ocurrido un error al borrar el registro",
          life: 3000,
        });
      }
    },
  });
}

function updateTableList() {
  dataViewRef.value.debounceRefreshAndUpdate();
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>
